import { Icon, Heading, css, MAGNETIC_TOKENS } from '@appd/uik';
import { useRouter } from 'next/router';

interface DashboardPageTitleProps {
  label: string;
  backURL?: string;
}

const DashboardPageTitle = ({ label, backURL }: DashboardPageTitleProps) => {
  const router = useRouter();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
    e.preventDefault();
    router.push(backURL ?? `/${router.query.appName}`).catch(() => {});
  };

  return (
    <div className="px-9 py-6 flex flex-col gap-1">
      <a href={backURL} onClick={handleClick} className={STYLES}>
        <Icon.Navigation.ArrowLeft size="SMALL" style={{ margin: '0 2px 0 -3px' }} />
        Dashboards
      </a>
      <Heading size="PRIMARY">{label}</Heading>
    </div>
  );
};

export default DashboardPageTitle;

const {
  COLORS: { INTERACT_BG, INTERACT_TEXT_WEAK },
  TYPOGRAPHY: { P3_EMPHASIS },
} = MAGNETIC_TOKENS;

const STYLES = css({
  ':hover': {
    '& path': { fill: `${INTERACT_BG} !important` },
    color: INTERACT_BG,
    textDecoration: 'underline',
    textUnderlineOffset: 2,
    cursor: 'pointer',
  },
  alignItems: 'center',
  alignSelf: 'flex-start',
  display: 'flex',
  color: INTERACT_TEXT_WEAK,
  font: P3_EMPHASIS,
  gap: 4,
  textDecoration: 'none',
});
